const OPEN_TYPES = {
	_self: link => (location.href = link),
	_blank: link => window.open(link),
}

const decodeLink = link => {
	// рішення для декодування символів, котрі виходять за межі ASCII
	// логіка з документації https://developer.mozilla.org/ru/docs/Glossary/Base64#the_unicode_problem
	try {
		return decodeURIComponent(
			atob(link) // декодуємо Base64
				.split('') // розбиваємо рядок на символи
				.map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)) // перетворюємо кожен символ у URL-код
				.join('') // Об'єднуємо назад у URL-кодований рядок
		)
	} catch (error) {
		console.warn('Error while decoding link', error)
	}
}

const initJSLinks = (data = 'lk') => {
	const elements = document.querySelectorAll(`[data-${data}]`)

	elements.forEach(element => {
		element.addEventListener('click', () => {
			const link = decodeLink(element.dataset[data])
			const target = element.dataset['target'] || '_self'
			const open = OPEN_TYPES[target]

			open(link)
		})
	})
}

export default initJSLinks
